<div class="container">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'map.sidebar.psa.attach_action_modal.title' | translate }}</h5>
    <h6>{{ data?.evento?.nome }} - {{ data?.evento?.tipologia }}</h6>
  </div>

  <div class="modal-body">
    <mat-form-field appearance="outline" class="w-100 mt-4">
      <input
        #myInput
        type="text"
        placeholder="{{ 'map.sidebar.psa.mitigating_action.search_placeholder' | translate }}"
        matInput
        (input)="onInput()"
        [(ngModel)]="searchTerm"
        [ngModelOptions]="{ standalone: true }"
        [matAutocomplete]="auto"
      />

      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="onOptionSelected($event.option.value)"
      >
        <mat-option *ngFor="let action of listActionsFiltered" [value]="action">
          {{ action.azione.nome }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-error *ngIf="!listActionsFiltered.length" class="font-08rem mb-3"
      >Non ci sono altre azioni da poter associare a questo evento</mat-error
    >

    <div *ngFor="let associatedAction of selectedActions" class="box-container p-1">
      <div class="d-flex align-items-center justify-content-start gap-1" style="width: 80%">
        <mat-icon class="remove-icon" (click)="onRemoveAction(associatedAction)">{{
          associatedAction?.old ? '' : 'delete'
        }}</mat-icon>
        <div class="d-flex flex-column align-items-start justify-content-center span-container">
          <span [title]="associatedAction.azione.nome">
            {{ associatedAction.azione.nome }}
          </span>
          <span [title]="associatedAction.azione.descrizione" class="font-09rem">{{
            associatedAction.azione.descrizione
          }}</span>
        </div>
      </div>

      <div class="d-flex align-items-center gap-1">
        <mat-icon [svgIcon]="'efficacia'" [matTooltip]="'Efficacia'"></mat-icon>
        <app-rank-selector
          [isDisabled]="associatedAction.old"
          [valueRank]="associatedAction.riduzione_probabilita"
          [defaultValue]="0"
          (rankChange)="onRankChange(associatedAction, $event, 'riduzione_probabilita')"
        ></app-rank-selector>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button mat-button type="button" (click)="onClose()">
      {{ 'map.sidebar.psa.attach_action_modal.button_cancel' | translate }}
    </button>
    <button mat-raised-button color="primary" type="button" [disabled]="!isAnyActionAdded()" (click)="onSave()">
      {{ 'map.sidebar.psa.attach_action_modal.button_save' | translate }}
    </button>
  </div>
</div>
